import React from 'react';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';

const INTRO_HELP = `
  <div>
    <p><strong>Purpose:</strong> In this section you will evaluate your client's abilities, including physical, visual, and cognitive.
    A strong understanding of these abilities is a key part of finding a good alternative access method, and is a cornerstone of 
    AT service delivery models such as <a href="https://atohio.org/sites/default/files/uploads/intro_to_at_assessment_models.pdf" target="_blank">the HAAT model and SETT framework</a>.</p>
    <p>We will help you identify potential physical access modalities and help you learn more about how to assess some of these modalities. We will also have you note key information about vision, language/cognition, and other issues that may impact access.</p>
  </div>
`

const propTypes = {
  firstName: PropTypes.string,
};

const defaultProps = {
  firstName: 'the client',
};

//content sub-component with unique content for this page
function EvalAbilitiesIntroContent(props) {
  const firstName = props.firstName;
  return(
    <>
    <p>This includes information about {firstName}'s:</p>
    <ul>
      <li>Physical abilities</li>
      <li>Vision</li>
      <li>Language and cognitive abilities</li>
      <li>Other user characteristics</li>
    </ul>
    <p>We'll walk through these items to make sure everyone has a clear understanding of {firstName}'s abilities and limitations.</p>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function EvaluateAbilitiesIntro(props) {
  const firstName = props.firstName;
  const pageData = {
    image: "./assets/images/target-icon.jpg",
    pageSectionClassName: "main-section eval",
    faIcon: "",
    majorHeading: "Evaluate Abilities",
    title: `Let's consider some of ${firstName}'s key abilities`,
    subTitle: "",
    learnMore: {linkText: "Learn More about what we are evaluating and why",
                title: "Evaluating Abilities",
                content: INTRO_HELP
                },
    nextRoute: "/evaluate-abilities/physical/basic", //temp static name for next page
    sidebar: false
  }

  console.log("Rendering EvaluateAbilitiesIntro");
  
  return(
    <>
    <Body page={pageData} contentComponent={<EvalAbilitiesIntroContent firstName={firstName}/>} />
    </>
  );
}

EvaluateAbilitiesIntro.propTypes = propTypes;
EvaluateAbilitiesIntro.defaultProps = defaultProps;

export default EvaluateAbilitiesIntro;